import React from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDButton from 'components/MDButton'
import { Divider, Stack, Grid } from '@mui/material'

const InvoiceModal = ({ open, onClose, data }) => {
  if (!data) return null



  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 750,
    maxHeight: '90vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  }

  return (
    <MDModal open={open} onClose={onClose}>
      <MDBox sx={style}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
          <MDTypography variant="h5" fontWeight="bold">Invoice Generated</MDTypography>
          <span style={{
            background: '#e8f5e9',
            color: '#2e7d32',
            padding: '4px 14px',
            borderRadius: 20,
            fontSize: 13,
            fontWeight: 'bold',
          }}>
            DISCOUNT BOOKING
          </span>
        </Stack>

        <Divider />

        <div id="invoice-print-area">
          <div className="header" style={{ display: 'flex', justifyContent: 'space-between', marginTop: 24, marginBottom: 24 }}>
            <div>
              <div style={{ fontSize: 28, fontWeight: 'bold', color: '#1a237e', letterSpacing: 2 }}>INVOICE</div>
              <div style={{ fontSize: 13, color: '#666', marginTop: 4 }}>#{data.bookingNo}</div>
            </div>
            <div style={{ textAlign: 'right', fontSize: 13, color: '#555' }}>
              <div><strong>Date:</strong> {data.createdAt}</div>
              <div><strong>Shoot Date:</strong> {data.shootDate}</div>
              <div><strong>Time:</strong> {data.startTime} – {data.endTime}</div>
            </div>
          </div>

          {/* Bill To */}
          <Grid container spacing={3} style={{ marginBottom: 24 }}>
            <Grid item xs={6}>
              <div style={{ background: '#f9f9f9', padding: 16, borderRadius: 8 }}>
                <div style={{ fontSize: 11, fontWeight: 'bold', color: '#999', marginBottom: 6, textTransform: 'uppercase' }}>Bill To</div>
                <div style={{ fontWeight: 'bold', fontSize: 15 }}>{data.customerName}</div>
                {data.company && <div style={{ fontSize: 13, color: '#555' }}>{data.company}</div>}
              </div>
            </Grid>
            <Grid item xs={6}>
              <div style={{ background: '#f9f9f9', padding: 16, borderRadius: 8 }}>
                <div style={{ fontSize: 11, fontWeight: 'bold', color: '#999', marginBottom: 6, textTransform: 'uppercase' }}>Listing</div>
                <div style={{ fontWeight: 'bold', fontSize: 15 }}>{data.listing}</div>
              </div>
            </Grid>
          </Grid>

          {/* Price Breakdown Table */}
          <table>
            <thead>
              <tr>
                <th>Description</th>
                <th style={{ textAlign: 'right' }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Base Price</td>
                <td style={{ textAlign: 'right' }}>${data.basePrice.toFixed(2)}</td>
              </tr>

              {data.serviceCharges > 0 && (
                <tr>
                  <td>Service Charges</td>
                  <td style={{ textAlign: 'right' }}>${data.serviceCharges.toFixed(2)}</td>
                </tr>
              )}

              {data.taxPrice > 0 && (
                <tr>
                  <td>Tax</td>
                  <td style={{ textAlign: 'right' }}>${data.taxPrice.toFixed(2)}</td>
                </tr>
              )}

              <tr className="discount-row" style={{ color: '#d32f2f' }}>
                <td>Discount ({data.discountPercentage}%)</td>
                <td style={{ textAlign: 'right', color: '#d32f2f' }}>-${data.discountAmount.toFixed(2)}</td>
              </tr>

              <tr className="total-row" style={{ fontWeight: 'bold', borderTop: '2px solid #333' }}>
                <td style={{ fontWeight: 'bold', fontSize: 15 }}>Total (100% Due)</td>
                <td style={{ textAlign: 'right', fontWeight: 'bold', fontSize: 15, color: '#1a237e' }}>
                  ${data.finalPrice.toFixed(2)}
                </td>
              </tr>
            </tbody>
          </table>

          <div style={{ marginTop: 32, padding: '12px 16px', background: '#e3f2fd', borderRadius: 8, fontSize: 13, color: '#0d47a1' }}>
            <strong>Note:</strong> This is a discount booking. The full discounted amount of <strong>${data.finalPrice.toFixed(2)}</strong> is due (100%).
          </div>
        </div>

        <Divider sx={{ my: 2 }} />

        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <MDButton variant="gradient" color="secondary" onClick={onClose}>Close</MDButton>
          {data.invoiceUrl && (
            <MDButton
              variant="gradient"
              color="success"
              onClick={() => window.open(data.invoiceUrl, '_blank')}
            >
              View Stripe Invoice
            </MDButton>
          )}
          {/* <MDButton variant="gradient" color="info" onClick={handlePrint}>Print Invoice</MDButton> */}
        </Stack>
      </MDBox>
    </MDModal>
  )
}

export default InvoiceModal
